import {IItemDetails} from 'models';

export const getAnswerStackData = (item: IItemDetails, answerStackId: number) => {
  return item.elements.filter((el) => el.questionAnswerStackId === answerStackId)[0];
};
